<template>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="input_start_date">{{startLabel}}</label>
      <flat-pickr class="form-control" v-model="start" :config="config.start"></flat-pickr>
      <b-form-feedback>Please input a valid date</b-form-feedback>
    </div>
    <div class="form-group col-md-6">
      <label for="input_end_date">{{endLabel}}</label>
      <flat-pickr class="form-control" v-model="end" :config="config.end"></flat-pickr>
      <b-form-feedback>Please input a valid date</b-form-feedback>
    </div>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
// import { Indonesian } from 'flatpickr/dist/l10n/id.js';

import 'flatpickr/dist/flatpickr.css';
import { parse } from 'date-fns';

export default {
  components: {
    flatPickr,
  },
  props: {
    name: String,
    startLabel: {
      type: String,
      default: 'Start Date',
    },
    endLabel: {
      type: String,
      default: 'End Date',
    },
  },
  data() {
    return {
      start: null,
      end: null,
      config: {
        start: {
          allowInput: true,
        },
        end: {
          allowInput: true,
        },
      },
    };
  },
  watch: {
    start(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.config.end, 'minDate', date);
        this.updateChanges();
      }
    },
    end(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.config.start, 'maxDate', date);
        this.updateChanges();
      }
    },
  },
  methods: {
    updateChanges() {
      this.$emit('change', this.name, {
        start: this.start,
        end: this.end,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/report_options/DateRange.vue